import React, { Component, Fragment } from 'react';
import styled from 'styled-components';
import { Grid } from 'layout-core-components';
import { Icon } from 'primitive-components';
import { colors } from 'bench-style-constants';

import DateFormatter from './DateFormatter';
import MessageInputBox from './MessageInputBox';

const DateWrapper = styled.div`
  color: ${colors.dust};
  font-size: 12px;
`;

const IconWrapper = styled.div`
  display: flex;
  svg {
    fill: ${colors.water};
  }
`;

const Username = styled.div`
  font-weight: 700;
`;

const Body = styled.div`
  white-space: pre-wrap;
`;

const Wrapper = styled.div`
  display: grid;
  grid-gap: 8px;
  font-size: 14px;
`;

const Button = styled.button`
  font-size: 12px;
  color: ${colors.water};
  background: transparent;
  padding: 0;

  &:hover {
    text-decoration: underline;
  }
`;

type InternalNoteProps = {
  id: number;
  username: string;
  body: string;
  timestamp: string;
  isFlagged: boolean;
  onDeleteNote: () => void;
  onEditNote: (message: string) => void;
  onFlagNote: () => void;
};

type InternalNoteState = {
  isEditing: boolean;
};

class InternalNote extends Component<InternalNoteProps, InternalNoteState> {
  state = {
    isEditing: false,
  };

  onEdit = () => {
    this.setState({ isEditing: true });
  };

  onCancelEdit = () => {
    this.setState({ isEditing: false });
  };

  onNoteSave = (message: string) => {
    const { body, onEditNote } = this.props;

    return message !== body ? onEditNote(message) : this.onCancelEdit();
  };

  render() {
    const { id, username, body, timestamp, isFlagged, onDeleteNote, onFlagNote } = this.props;

    const { isEditing } = this.state;

    return (
      <Wrapper>
        <Username>{username}</Username>
        {isEditing && (
          <Fragment>
            <MessageInputBox
              value={body}
              submitButtonText="save"
              onPost={message => this.onNoteSave(message)}
              data-test-id={`internal-note-${id}-edit-textarea`}
            />
            <Button onClick={this.onCancelEdit}>Cancel</Button>
          </Fragment>
        )}
        {!isEditing && (
          <Fragment>
            <Body>{body}</Body>
            <Grid row="1fr auto auto auto" columnSpacing="medium">
              <DateWrapper>
                <DateFormatter text={timestamp} unixTimestamp />
              </DateWrapper>
              <Button onClick={onFlagNote}>
                <IconWrapper>
                  {isFlagged ? (
                    <Icon icon="flagFilled" size="small" />
                  ) : (
                    <Icon icon="flagUnfilled" size="small" />
                  )}
                </IconWrapper>
              </Button>
              <Button onClick={this.onEdit} data-test-id={`internal-note-${id}-edit-button`}>
                Edit
              </Button>
              <Button onClick={onDeleteNote}>Delete</Button>
            </Grid>
          </Fragment>
        )}
      </Wrapper>
    );
  }
}

export default InternalNote;
